//
//
//
//
//
//
//
//
//

export default {
  name: 'App',
  computed: {
    key() {
      return Math.random() + Date.now()
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue